import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImportItemsQuoteService {
  private readonly STORAGE_KEY = 'destinationQuoteId';
  private destinationQuoteId$ = new BehaviorSubject<string | null>(this.getDestinationQuoteId());
  private selectedQuoteId$ = new BehaviorSubject<string | undefined>(undefined);

  constructor() {
    // Listen to storage events from other tabs/windows
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === this.STORAGE_KEY) {
        this.destinationQuoteId$.next(event.newValue);
      }
    });
  }

  /**
   * Get the current destination quote ID
   */
  getDestinationQuoteId(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  /**
   * Set the destination quote ID
   */
  setDestinationQuoteId(quoteId: string): void {
    localStorage.setItem(this.STORAGE_KEY, quoteId);
    this.destinationQuoteId$.next(quoteId);
  }

  /**
   * Remove the destination quote ID
   */
  removeDestinationQuoteId(): void {
    localStorage.removeItem(this.STORAGE_KEY);
    this.destinationQuoteId$.next(null);
    this.removeSelectedQuoteId();
  }

  /**
   * Observable stream of destination quote ID changes
   */
  getDestinationQuoteId$(): Observable<string | null> {
    return this.destinationQuoteId$.asObservable();
  }

  setSelectedQuoteId(quoteId: string): void {
    this.selectedQuoteId$.next(quoteId);
  }

  getSelectedQuoteId$(): Observable<string | undefined> {
    return this.selectedQuoteId$.asObservable();
  }

  removeSelectedQuoteId(): void {
    this.selectedQuoteId$.next(undefined);
  }
}
